/**
 * frontend/src/lib/permissions.js
 * V2-T1 + V5 — Permissions par rôle.
 */
export const ROLES = { OWNER:'owner', MANAGER:'manager', FOREMAN:'foreman', WORKER:'worker' };

export function can(user, action) {
  const role = user?.role;
  switch (action) {
    case 'menu:company_settings':       return role === 'owner';
    case 'menu:billing':                return role === 'owner';
    case 'menu:payroll_variables':      return role === 'owner';
    case 'menu:rgpd':                   return role === 'owner';
    case 'menu:compare_plans':          return role === 'owner' || role === 'manager';
    case 'menu:plan_trial':             return role === 'owner' || role === 'manager';
    case 'menu:notifications_prefs':    return true;
    case 'action:create_site':          return role === 'owner' || role === 'manager';
    case 'action:manage_users':         return role === 'owner' || role === 'manager';
    case 'action:view_budget':          return role === 'owner' || role === 'manager';
    case 'action:view_subcontractors':  return role === 'owner' || role === 'manager';
    case 'action:manage_client_portal': return role === 'owner' || role === 'manager';
    // V5-T4 : reporting
    case 'action:view_reports':         return role === 'owner' || role === 'manager';
    case 'sidebar:plan_chip':           return role === 'owner' || role === 'manager';
    default: return false;
  }
}

export function getMenuItems(role) {
  const base = ['profile', 'notifications_prefs'];
  if (role === 'owner')   return [...base, 'company_settings', 'billing', 'payroll_variables', 'rgpd', 'compare_plans'];
  if (role === 'manager') return [...base, 'compare_plans'];
  return base;
}
